export const MAX_CHARACTERS = 250;
export const NAME = 'racking-proposals';
export const COLUMNS_CONFIG = {
    name: { label: 'Name', is_active: true, required: true },
    panels_counter: { label: 'Panel_plural', is_active: true, required: false },
    type: {
        is_active: true,
        label: 'Type',
        required: false,
    },
    project: { label: 'Project', is_active: true, required: false },
    contact: { label: 'Contact', is_active: true, required: false },
    created_by: { label: 'User', is_active: true, required: false },
    date: { label: 'Date', is_active: true, required: false },
};
